var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$store.state.user.loggedIn)?_c('core-toolbar'):_vm._e(),(_vm.$store.state.user.loggedIn)?_c('core-drawer'):_vm._e(),_c('core-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }